import { Button, Center, Group, Modal, Switch, Text, Tooltip } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconBan, IconBarrierBlock, IconBlocks, IconEdit, IconEye, IconTrash } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { updateUserStatus } from '../../../api/user';
import { removeAgencyCode, blockFromAgencies } from '../../../api/user';
import { successNotification } from '../../../utility/notification';
import classes from '../User.module.css';

function ActionCell({ row, queryKey }) {
    const [isSwitchOn, setIsSwitchOn] = useState(row.active);
    const [opened, { open, close }] = useDisclosure(false);
    const [deleteDialogOpened, { open: openDeleteDialog, close: closeDeleteDialog }] = useDisclosure(false);
    const [blockAgencyDialogOpened, { open: openBlockAgencyDialog, close: closeBlockAgencyDialog }] = useDisclosure(false);

    const handleSwitchChange = () => {

        close();
        setIsSwitchOn(!isSwitchOn)

    };

    const { isPending, mutate } = useMutation({
        mutationFn: updateUserStatus,
        onSuccess: (res) => {
            successNotification({
                message: res?.message
            });
            handleSwitchChange()
        }
    })
    const queryclient = useQueryClient()
    const { isDeletePending, mutate: mutateDelete } = useMutation({
        mutationFn: removeAgencyCode,
        onSuccess: async (res) => {
            await queryclient.invalidateQueries({
                queryKey
            })

            successNotification({
                message: res?.message
            });


            handleDeleteChange()
        }
    })

    const { isBlockAgencyPending, mutate: mutateBlockAgency } = useMutation({
        mutationFn: blockFromAgencies,
        onSuccess: async (res) => {
            await queryclient.invalidateQueries({
                queryKey
            })

            console.log('res', res?.message);

            successNotification({
                message: res?.message
            });


            handleBlockAgencyChange()
        }
    })

    const handleDeleteChange = () => {

        closeDeleteDialog();

    };

    const handleBlockAgencyChange = () => {

        closeBlockAgencyDialog();


    };

    return (
        <>
            <Group justify="center" p="md">
                {/* Switch for activating/inactivating user */}
                <Switch
                    type="checkbox"
                    checked={isSwitchOn}
                    onChange={open}
                />
                {/* Link to user details */}
                <Link to={`/user/${row.id}/details`}>
                    <div className={classes.icon_button}>
                        <Tooltip label="View">
                            <IconEye style={{ color: 'white', fontSize: '20px', alignItems: 'center' }} />
                        </Tooltip>
                    </div>
                </Link>
                {/* Button to delete agency code */}
                {row.agency_code ?
                    <div className={classes.icon_button_danger}>
                        <Tooltip label="Delete Agency Code">
                            <IconTrash
                                style={{ color: 'white', fontSize: '20px', alignItems: 'center' }}
                                onClick={openDeleteDialog}
                            >

                            </IconTrash>
                        </Tooltip>
                    </div> : null
                }

                {row.is_blocked_from_agencies ?
                    <div className={classes.icon_button_primary}>
                        <Tooltip label="Unblock from using Agencies">
                            <IconBan
                                style={{ color: 'white', fontSize: '20px', alignItems: 'center' }}
                                onClick={openBlockAgencyDialog}
                            >

                            </IconBan>
                        </Tooltip>
                    </div> : <div className={classes.icon_button_danger}>
                        <Tooltip label="Block from using Agencies">
                            <IconBan
                                style={{ color: 'white', fontSize: '20px', alignItems: 'center' }}
                                onClick={openBlockAgencyDialog}
                            >

                            </IconBan>
                        </Tooltip>
                    </div>
                }

                {/* Modal for activation/inactivation confirmation */}
                <Modal opened={opened} onClose={close} centered title="Confirm">
                    <Text>
                        Are you sure you want to {!isSwitchOn ? 'Activate' : 'Inactive'} the user?
                    </Text>
                    <Center mt="md">
                        <Button
                            variant="gradient"
                            gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                            onClick={() => mutate({
                                id: row?.id,
                                status: !isSwitchOn,
                            })}
                            loading={isPending}
                        >
                            Confirm
                        </Button>
                    </Center>
                </Modal>

                {/* Modal for deleting agency code */}
                <Modal opened={deleteDialogOpened} onClose={closeDeleteDialog} centered title="Delete Agency Code Confirmation">
                    <Text>Are you sure you want to unblock user to use any agency code ?</Text>
                    <Center mt="md">
                        <Button
                            variant="gradient"
                            gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                            onClick={() => mutateDelete({ id: row?.id })}
                            loading={isDeletePending}
                        >
                            Confirm
                        </Button>
                    </Center>
                </Modal>
                <Modal opened={blockAgencyDialogOpened} onClose={closeBlockAgencyDialog} centered title="Unblock user from Agencies Confirmation">
                    <Text>Are you sure you want to block user to use any agency code ?</Text>
                    <Center mt="md">
                        <Button
                            variant="gradient"
                            gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                            onClick={() => mutateBlockAgency({ id: row?.id })}
                            loading={isBlockAgencyPending}
                        >
                            Confirm
                        </Button>
                    </Center>
                </Modal>
                <Modal opened={blockAgencyDialogOpened} onClose={closeBlockAgencyDialog} centered title="Block user from Agencies Confirmation">
                    <Text>Are you sure you want to delete the agency code from this user?</Text>
                    <Center mt="md">
                        <Button
                            variant="gradient"
                            gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                            onClick={() => mutateBlockAgency({ id: row?.id })}
                            loading={isBlockAgencyPending}
                        >
                            Confirm
                        </Button>
                    </Center>
                </Modal>
            </Group>
        </>
    )
}

export default ActionCell
